export enum NotificationDeliveryTarget {
  All = 1,
  Personal = 2,
}

type NotificationDeliveryTargetMap = {
  [P in NotificationDeliveryTarget]: { name: string };
};

export const NotificationDeliveryTargetMap: NotificationDeliveryTargetMap = {
  1: { name: '全体へのお知らせ' },
  2: { name: 'あなたへのお知らせ' },
};

export type NotificationDeliveryType = 1 | 2 | 3 | 99 | 100;

type NotificationDeliveryTypeMap = {
  [P in NotificationDeliveryType]: { name: string };
};

export const NotificationDeliveryTypeMap: NotificationDeliveryTypeMap = {
  1: { name: 'リースファンド' },
  2: { name: '国内不動産' },
  3: { name: '海外不動産' },
  99: { name: 'その他' },
  100: { name: '全体' },
};
